<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Keypad" class="d-icon d-icon--keypad" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M2.25 3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM5 3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm2.75 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm-5.5 2.75a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm2.75 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm2.75 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM2.25 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM5 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm2.75 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconKeypad',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
